import { useState } from "react";
import { ArrowRight, ChevronLeft, ChevronRight } from "lucide-react";
import { QrMedia } from "./QrMedia";

export const QrBanners = ({ banners = [], onOpen }) => {
  const [index, setIndex] = useState(0);
  const banner = banners[index % (banners.length || 1)];
  if (!banner) return null;
  return <section className="qr-banner" aria-label="Restaurant offers" data-testid="qr-offer-banner">
    <button type="button" className="qr-banner-link" onClick={() => onOpen(banner)} data-testid={`qr-banner-link-${banner.id}`} aria-label={banner.title || "View offer"}>
      <QrMedia src={banner.image_url} alt={banner.title || "Restaurant offer"} size="large" priority className="qr-banner-image" testId="qr-banner-photo" />
      <div className="qr-banner-caption"><div><h2 data-testid="qr-banner-title">{banner.title || "Explore the menu"}</h2>{banner.subtitle && <p data-testid="qr-banner-subtitle">{banner.subtitle}</p>}</div><ArrowRight size={20} /></div>
    </button>
    {banners.length > 1 && <div className="qr-banner-controls">
      <button type="button" onClick={() => setIndex((i) => (i - 1 + banners.length) % banners.length)} aria-label="Previous banner" data-testid="qr-banner-previous"><ChevronLeft size={18} /></button>
      <span data-testid="qr-banner-position">{index % banners.length + 1} / {banners.length}</span>
      <button type="button" onClick={() => setIndex((i) => (i + 1) % banners.length)} aria-label="Next banner" data-testid="qr-banner-next"><ChevronRight size={18} /></button>
    </div>}
  </section>;
};